import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

api.interceptors.response.use(
    (resp) => resp,
    (error) => {
        const status = error.response?.status;
        const url = error.config?.url || "";
        // Auto-logout em 401 em rotas /admin/* (token expirado/inválido)
        if (status === 401 && url.includes("/admin/") && !url.includes("/auth/")) {
            localStorage.removeItem("admin_token");
            localStorage.removeItem("admin_email");
            if (!window.location.pathname.startsWith("/admin/login")) {
                window.location.href = "/admin/login?expired=1";
            }
        }
        return Promise.reject(error);
    }
);

export const fmtPrice = (v) =>
    new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v);
